import { TextField } from '@ovComponents/2-component/textField/textField';
import {
  isParticipantNumberLengthValid,
  PARTICIPANT_NUMBER_LENGTH,
} from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositFieldOptions';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useTranslation } from 'react-i18next';

export type DepositExternalTransferParticipantNumberProp = {
  participantNumber?: string;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
};

export const DepositExternalTransferParticipantNumber = ({
  participantNumber,
  focused,
  onFocus,
  onChange,
}: DepositExternalTransferParticipantNumberProp) => {
  const { t } = useTranslation('workflowCompletions');
  const participantNumberValue = participantNumber ?? '';
  const participantNumberTouched = focused.includes('participantNumber');
  const participantNumberMissing =
    participantNumberTouched && participantNumberValue.length === 0;
  const participantNumberInvalidLength =
    participantNumberTouched &&
    !isParticipantNumberLengthValid(participantNumberValue);

  return (
    <TextField
      testId='participant-number-for-us-transfers'
      infoTooltip={t('transfer:participantNumberTooltip')}
      onChange={(e: any) => {
        const digitsOnly = e.target.value
          .replace(/\D/g, '')
          .slice(0, PARTICIPANT_NUMBER_LENGTH);
        onChange({ participantNumber: digitsOnly });
      }}
      label={t('transfer:participantNumber')}
      fullWidth
      sx={{ mt: 2, mb: 2 }}
      value={participantNumberValue}
      inputProps={{
        maxLength: PARTICIPANT_NUMBER_LENGTH,
        inputMode: 'numeric',
        pattern: '[0-9]*',
      }}
      onBlur={() => onFocus('participantNumber')}
      error={participantNumberMissing || participantNumberInvalidLength}
      errorText={
        participantNumberInvalidLength
          ? t('transfer:participantNumberLengthError')
          : undefined
      }
    />
  );
};
